import axios from "axios";
import Vue from "vue";
import router from "../router";
import store from "../store";
import postMessageIframe from "../utils/postMessageIframe.js";
const http = axios.create({
  baseURL: `${window.location.origin}/api`,
  // baseURL: `${window.location.origin}`,
});
//添加请求拦截器，在请求头中加token
http.interceptors.request.use(
  (config) => {
    if (!config.skipAuthorization && localStorage.getItem("SdkAuthorization")) {
      config.headers.Authorization = localStorage.getItem("SdkAuthorization");
      // config.headers["game-id"] = localStorage.getItem("SdkGameId");
      // config.headers["game-id"] = "75dd00ef7f2f44c18409dc2265bff61d";
      // config.headers["app-licence-key"] = "1856161436779388929";
      config.headers["game-id"] = process.env.VUE_APP_GAME_ID;
      config.headers["app-licence-key"] = process.env.VUE_APP_LICENCE_KEY;
      config.headers["channel-id"] = localStorage.getItem("SdkChannelId");
      // config.headers["channel-id"] = "qd001";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// // 添加响应拦截器
http.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    if (response.data.code === 401) {
      // token的报错 统一都会提示401
      Vue.prototype.$toast.fail({
        message: response.data.msg,
      });
      if (store.state.appOrH5 === "H5") {
        postMessageIframe.sendMessageWithCallback({ type: "tcExitLogin" });
      } else {
        dsBridge.call("exitLogin", function (v) {}); //退出登录方法， 会删除token 用户id 和游戏id
      }
      store.commit("changeToken", {
        access_token: "",
      });
      store.state.isFirstLoad = true;
      router.push("/login");
      // 如果token报错的时候 需要删除token 方法还未写。
      // dsBridge.call("cleanToken", function (data) {});
    } else if (response.data.code === 500) {
      Vue.prototype.$toast.fail({
        message: response.data.msg,
      });
    }
    return response;
  },
  function (error) {
    console.log(error);
    // // 对响应错误做点什么
    // if (error.response.status == 403) {
    //   Vue.prototype.$toast.fail({
    //     message: rror.response.data.errs,
    //   });
    //   router.push("/login");
    // }
    // return Promise.reject(error);
  }
);

export default http;
